import React from "react";
import CartDropdownItem from "./CartDropdownItem";
import Price from "../../../common/components/Price";
import { useTranslations } from "next-intl";
import useBetaMode from "../../../auth/hooks/useBetaMode";
import useUpdateCartItem from "../../hooks/useUpdateCartItem";
import useRemoveCartItem from "../../hooks/useRemoveCartItem";
import Button from "../../../theme/components/Button";

const CheckoutLink = ({ children, clientId }) => {
  const { isBetaModeEnabled } = useBetaMode();
  return isBetaModeEnabled ? (
    <Button appearance="primary" href={`/portal/checkout?clientId=${clientId}`}>
      {children}
    </Button>
  ) : (
    <Button appearance="primary" icon-position="left" href={`/checkout`}>
      {children}
    </Button>
  );
};

const CartDropdownItems = ({ cart }) => {
  const { items, itemsTotal } = cart || {};
  const t = useTranslations();
  const { updateCartItem } = useUpdateCartItem();
  const { removeCartItem } = useRemoveCartItem();

  const onChangeItemQuantity = (itemId) => (quantity) => {
    updateCartItem({ itemId, quantity });
  };

  const onRemoveItem = (itemId) => () => {
    removeCartItem(itemId);
  };

  return (
    <>
      {items && items.length > 0 && (
        <div className="cart-action-area drop-shadow pt-2 fs-6">
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-2">
            <div className="font-weight-normal">
              {t("total_including_taxes")}
            </div>
            <div>
              <Price {...itemsTotal} />
            </div>
          </div>
          <div className="w-100">
            <CheckoutLink clientId={cart.clientId}>
              {t("checkout")}
            </CheckoutLink>
          </div>
        </div>
      )}
      <div className="cart__items pt-4">
        {(!items || items.length === 0) && (
          <div className="text-center mt-3">{t("your_bag_is_empty")}</div>
        )}
        {items &&
          items.map((item) => {
            return (
              <CartDropdownItem
                onChangeItemQuantity={onChangeItemQuantity(item._id)}
                onRemoveItem={onRemoveItem(item._id)}
                product={item}
                hideAvailability
                key={item._id}
                {...item}
                disableNavigation={true}
              />
            );
          })}
      </div>
    </>
  );
};

export default CartDropdownItems;
